<script>
  import {viewMode} from './stores/LocalStorage.js';
  import loggedInUser from './stores/LoggedInUser.js';
  import {createEventDispatcher} from 'svelte';
    const dispatch = createEventDispatcher();
    const elementAction = (tag) => {
      dispatch('elementAction', {tag});
      showMobileNav = false;
      viewMode.update({tag});
  }
  let showMobileNav = false;

</script>

<!-- svelte-ignore a11y-no-redundant-roles -->
<nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <h1 class="title is-size-4 mb-1 mr-6 has-text-white" on:keydown={() => {}} on:click={() => viewMode.update({tag: 'home'})}>tellsens.io</h1>
      </a>
      <!-- svelte-ignore a11y-missing-attribute -->
      <a role="button" class="navbar-burger has-text-white" on:keydown={() => {}} on:click={() => showMobileNav = showMobileNav? false : true} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  
    <div class="navbar-menu" class:is-active={showMobileNav}>
      <div class="navbar-start">
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="navbar-item has-text-white" name="home" on:keydown={() => {}} on:click={(e) => elementAction(e.target.name)} class:navbar-item-selected={$viewMode.tag === 'home'}>
          Home
        </a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="navbar-item has-text-white" name="apps" on:keydown={() => {}} on:click={(e) => elementAction(e.target.name)} class:navbar-item-selected={$viewMode.tag === 'apps'}>
          Apps
        </a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="navbar-item has-text-white" name="docs" on:keydown={() => {}} on:click={(e) => elementAction(e.target.name)} class:navbar-item-selected={$viewMode.tag === 'docs'}>
          Documentation
        </a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="navbar-item has-text-white" name="pricing" on:keydown={() => {}} on:click={(e) => elementAction(e.target.name)} class:navbar-item-selected={$viewMode.tag === 'pricing'}>
          Pricing
        </a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <!-- <a class="navbar-item has-text-white" name="contact-us" class:navbar-item-selected={$viewMode.tag === 'contact-us'}>
          Contact us
        </a> -->
      </div>
      <div class="navbar-end">
        <div class="navbar-item has-text-white">
          {#if $loggedInUser.user_id} <p>{$loggedInUser.user_id}</p> {/if}
        </div>

        {#if $loggedInUser.user_id}
          <!-- svelte-ignore a11y-missing-attribute -->
          <a class="navbar-item has-text-white" href="/.auth/logout?post_logout_redirect_uri=/">Log out</a>
        {/if}
        {#if !$loggedInUser.user_id}
          <!-- svelte-ignore a11y-missing-attribute -->
          <a class=" navbar-item has-text-white" href="/.auth/login/aad?post_login_redirect_uri=/">Log in</a>
        {/if}
      </div>
    </div>
  </nav>
  <style>
    .navbar, .navbar-menu{
      background-color: #25557c;
    }
    .navbar-item-selected {
      background-color: #2b6391;
    }
    a:hover, a:active, a:focus {
      background-color: #2b6391;
      color: white !important;
    }    
  </style>
